var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-685.000000, -4114.000000)","stroke":"#FFFFFF"},React.createElement("g",{"transform":"translate(685.000000, 4114.000000)"},React.createElement("g",null,[React.createElement("path",{"d":"M52.1957524,46 L25.8042476,46 L39,24.8867962 L52.1957524,46 Z","strokeWidth":"2","fill":"#FFFFFF","transform":"translate(39.000000, 35.000000) rotate(-270.000000) translate(-39.000000, -35.000000) ","key":0}),React.createElement("circle",{"strokeWidth":"3","cx":"35","cy":"35","r":"33.5","key":1})])))));
}

IconPlay.defaultProps = {"width":"70px","height":"70px","viewBox":"0 0 70 70","version":"1.1"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
